<template>
  <inline-svg v-if="flagUrl" :src="flagUrl" :width="32" />
</template>

<script setup>
import { ref, watch } from "vue"

import InlineSvg from "vue-inline-svg"

import * as quasarUtils from "@/services/quasarUtils.js"

const props = defineProps({
  code: {
    type: String,
    required: true
  }
})

const flagUrl = ref("")

const loadFlag = async (code) => {
  try {
    const flagModule = await import(`@/assets/flags/${code}.svg`)
    flagUrl.value = flagModule.default
  } catch (err) {
    quasarUtils.handleError(`Flag for country code ${code} not found`, err)
    flagUrl.value = ""
  }
}

watch(
  () => props.code,
  (newCode) => {
    if (newCode) {
      loadFlag(newCode)
    }
  },
  { immediate: true }
)
</script>
